import { Box, HStack, Icon } from "@chakra-ui/react"
import isEqual from "lodash.isequal"
import type { FC } from "react"
import Link from "@/common/components/Link"
import SimulationResultBadge from "@/proposal/components/simulation/common/SimulationResultBadge"
import { mapSimulationStatusToSimulationResult } from "@/proposal/components/simulation/helpers/simulation"
import type { SimulationStatus } from "@/query/graphql"
import { ArrowUpRight } from "@/ui/components/icons/font-awesome/ArrowUpRight"

type SimulationLinkProps = {
  result: SimulationStatus
  url?: string
}

const SimulationText: React.FC<SimulationLinkProps> = ({ result, url }) => {
  const displayLinkIcon = url && url.trim() !== ""

  return (
    <HStack align="center" justify="end">
      <SimulationResultBadge
        result={mapSimulationStatusToSimulationResult(result)}
      />

      {displayLinkIcon ? (
        <Icon as={ArrowUpRight} color="gray.500" h="16px" w="16px" />
      ) : (
        <Box width="16px" />
      )}
    </HStack>
  )
}

const SimulationLink: FC<SimulationLinkProps> = ({ result, url }) => {
  // TODO(@nicolas): !isEqual(result as string, "unknown") should be replaced to
  // result !== SimulationStatus.Unknown when this state is available in the API
  const hasValidUrl =
    url && url.trim() !== "" && !isEqual(result as string, "unknown")

  return (
    <>
      {hasValidUrl ? (
        <Link isExternal _hover={{ textDecoration: "none" }} href={url}>
          <SimulationText result={result} url={url} />
        </Link>
      ) : (
        <SimulationText result={result} />
      )}
    </>
  )
}

export default SimulationLink
